import React from "react";
import { Select, Space } from "antd";
import { SERVICE_PROVIDER_DETAILS } from "../../constants/serviceProviders";

const UnrecognizedStatusOrderFilters = ({ filters, onFiltersChange }) => {
  return (
    <Space size="large">
      <div>
        Courier :{` `}
        <Select
          placeholder="ALL"
          style={{ width: 200 }}
          allowClear
          onChange={(value) =>
            onFiltersChange({ ...filters, serviceProvider: value })
          }
        >
          {SERVICE_PROVIDER_DETAILS.map((serviceProvider) => (
            <Select.Option value={serviceProvider.key}>
              {serviceProvider.name}
            </Select.Option>
          ))}
        </Select>
      </div>
    </Space>
  );
};

export default UnrecognizedStatusOrderFilters;
